import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { PatientInsuranceType } from '@enum/patient/PatientInsuranceType';
import { PatientStatus } from '@enum/patient/PatientStatus';

export class PatientAdminPageCriteriaDTO extends PageCriteriaDTO {
  public insuranceType: PatientInsuranceType;

  public status: PatientStatus;
}